import { Purchases, LOG_LEVEL } from '@revenuecat/purchases-capacitor';
import { Capacitor } from '@capacitor/core';

const REVENUECAT_APPLE_API_KEY = process.env.REACT_APP_REVENUECAT_APPLE_API_KEY || 'public_apple_key_placeholder';
const REVENUECAT_GOOGLE_API_KEY = process.env.REACT_APP_REVENUECAT_GOOGLE_API_KEY || 'public_google_key_placeholder';

export const IapService = {
    initialize: async (userId) => {
        if (Capacitor.getPlatform() === 'web') return; // Skip for web
        
        try {
            await Purchases.setLogLevel({ level: LOG_LEVEL.DEBUG });
            
            if (Capacitor.getPlatform() === 'ios') {
                await Purchases.configure({ apiKey: REVENUECAT_APPLE_API_KEY, appUserID: userId });
            } else if (Capacitor.getPlatform() === 'android') {
                await Purchases.configure({ apiKey: REVENUECAT_GOOGLE_API_KEY, appUserID: userId });
            }
            console.log("RevenueCat initialized successfully for", Capacitor.getPlatform());
        } catch (error) {
            console.error("Error initializing RevenueCat:", error);
        }
    },

    getOfferings: async () => {
        if (Capacitor.getPlatform() === 'web') return null;
        
        try {
            const offerings = await Purchases.getOfferings();
            return offerings;
        } catch (error) {
            console.error("Error fetching offerings:", error);
            return null;
        }
    },

    purchasePackage: async (pkg) => {
        if (Capacitor.getPlatform() === 'web') return null;

        try {
            const { customerInfo } = await Purchases.purchasePackage({ aPackage: pkg });
            return customerInfo;
        } catch (error) {
            console.error("Purchase failed:", error);
            throw error;
        }
    },

    restorePurchases: async () => {
        if (Capacitor.getPlatform() === 'web') return null;

        try {
            const customerInfo = await Purchases.restorePurchases();
            return customerInfo;
        } catch (error) {
            console.error("Failed to restore purchases:", error);
            throw error;
        }
    },
    
    checkProStatus: async () => {
        if (Capacitor.getPlatform() === 'web') return false;
        
        try {
            const customerInfo = await Purchases.getCustomerInfo();
            // Assuming the entitlement identifier is 'pro_access'
            return typeof customerInfo.entitlements.active['pro_access'] !== 'undefined';
        } catch (error) {
            console.error("Failed to check pro status:", error);
            return false;
        }
    }
};
